import type { InterestType } from '$gql/types-mutations';

export const success = $state({
	type: null as null | InterestType,
});

export const showSuccess = (type: InterestType) => {
	success.type = type;
};

export const hideSuccess = () => {
	success.type = null;
};
